import { isNull } from 'utils/tsHelpers';
import { ElementType, useIndex } from '../contexts/elementIndex';

export const useIsIfClause = () => {
  const clauseIndex = useIndex(ElementType.clause);
  return isNull(clauseIndex);
};
